import Header from './components/Header';
import Hero from './components/Hero';
import ContactSection from './components/ContactSection';
import CardsSection from './components/CardsSection';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import AppSection from './components/AppSection';
import FaqSection from './components/FaqSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <ContactSection />
        <CardsSection />
        <CarouselSection />
        <AboutSection />
        <CommentsSection />
        <IndexSection />
        <TopicsSection />
        <MediaSection />
        <UpdatesSection />
        <FeaturesSection />
        <AppSection />
        <FaqSection />
        <RankingSection />
      </main>
      <Footer />
    </>
  );
}